var map = {
	"./app-google-da-DK.svg": 4460,
	"./app-google-de-DE.svg": 43262,
	"./app-google-en-GB.svg": 88452,
	"./app-google-en-US.svg": 56591,
	"./app-google-es-ES.svg": 35752,
	"./app-google-es-MX.svg": 81627,
	"./app-google-fr-FR.svg": 4576,
	"./app-google-it-IT.svg": 39286,
	"./app-google-nb-NO.svg": 63533,
	"./app-google-nl-NL.svg": 2620,
	"./app-google-pl-PL.svg": 40884,
	"./app-google-pt-BR.svg": 48456,
	"./app-google-pt-PT.svg": 93588,
	"./app-google-sv-SE.svg": 6533
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38934;